import { render, staticRenderFns } from "./UcInvoiceKindBadge.yaml?vue&type=template&id=6701c683&component"
import script from "./UcInvoiceKindBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceKindBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports